import ResourceDownloadTemplate from '@/components/templates/resource-download';
import { ResourcePathsQuery, ResourceQuery, ResourceQueryVariables } from '@/graphql';
import ResourceQueryDocument from '@/graphql/queries/Resource.gql';
import ResourcePathsQueryDocument from '@/graphql/queries/ResourcePaths.gql';
import { getSingleLink } from '@/lib/craft-utils';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';

export default ResourceDownloadTemplate;

export const getStaticPaths = getStaticPagePaths('resources', async (context) => {
  if (process.env.SKIP_BUILD_STATIC_GENERATION) {
    return {
      paths: [],
      fallback: 'blocking',
    }
  }

  const client = new CraftClient();

  const data = await client.request<ResourcePathsQuery>(ResourcePathsQueryDocument);

  const paths =
    data.entries
      ?.filter((entry) => {
        return entry?.__typename !== 'resources_resourceExternal_Entry';
      })
      .map((path) => ({
        params: {
          slug: path?.slug!,
        },
      })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `resources/${params?.slug}`,
  async ({ client, context: { params } }) => {
    const { entry } = await client.request<ResourceQuery, ResourceQueryVariables>(ResourceQueryDocument, {
      slug: params?.slug!,
    });

    if (!entry) {
      return { notFound: true };
    }

    if (entry.__typename === 'resources_resourceExternal_Entry') {
      const linkOnly = getSingleLink(entry.linkOnly);

      if (!linkOnly) {
        return { notFound: true };
      }

      return {
        props: {},
        redirect: {
          destination: linkOnly.url,
          permanent: true,
        },
      };
    }

    return {
      props: {
        entry,
      },
    };
  },
);
